export class FundoFixo {
  empresa: string;
  numCaixa: string;
  nomeCaixa: string;
  saldoInicial: number;
  numNomeCaixa: string;
}